import { FC, useEffect } from "react";

import { StudentDemoAIPrompt } from "./StudentDemoAIPrompt";

import { OrgRubricSettings } from "components/materials/home/admin/settings/AdminRubricSettings";
import { AdminSettingsMain } from "components/materials/home/admin/settings/AdminSettingsMain";
import { t } from "i18n/i18n";
import { useCapabilities } from "store/capability-hooks";
import { storeApi, useAppSelector } from "store/index";
import {
  selectCurrentUserIsMPAdmin,
  selectFullSectionsSorted,
  selectIsEditModeEnabled,
} from "store/selectors";
import { useListSelector } from "store/store-hooks";

export const AdminSettingsPanel: FC = () => {
  const sections = useListSelector(selectFullSectionsSorted);
  const isMpAdmin = useAppSelector(selectCurrentUserIsMPAdmin);
  const editModeEnabled = useAppSelector(selectIsEditModeEnabled);
  const { canAuthorOrg } = useCapabilities();
  const canEdit = editModeEnabled && canAuthorOrg;

  useEffect(() => {
    storeApi.orgs.list();
  }, []);

  return (
    <div className="h-full overflow-y-auto">
      <h3 className="h3 mt-0 text-black-tint-40">{t("home.settings.institution_settings")}</h3>
      <AdminSettingsMain readOnly={!canEdit} sections={sections} />
      <OrgRubricSettings readOnly={!canEdit} />

      {isMpAdmin && <StudentDemoAIPrompt readOnly={!canEdit} />}
    </div>
  );
};
